import { createApiHooks, schemaToQueryParameters } from '@apis/next/common';
import { Staff, StaffPages, StaffSearchQuery } from '@models/next/Staff';
import { z } from 'zod';

export const dashboardStaffApis = createApiHooks('/dashboard/staff', [
  {
    method: 'get',
    path: '/',
    parameters: schemaToQueryParameters(StaffSearchQuery),
    response: StaffPages,
  },
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: Staff,
  },
]);
